import React from 'react';
import { Icon } from '@iconify/react';
import reactIcon from '@iconify/icons-logos/react';
import tailwindcssIcon from '@iconify/icons-logos/tailwindcss-icon';
import nextjsIcon from '@iconify/icons-logos/nextjs';
import mongodbIcon from '@iconify/icons-logos/mongodb';
import expressjsIcon from '@iconify/icons-logos/express';
import nodejsIcon from '@iconify/icons-logos/nodejs';
import firebaseIcon from '@iconify/icons-logos/firebase';


const skills = [
  <a href="https://reactjs.org" className="focus:outline-none">
    <Icon className="text-5xl" icon={reactIcon} />
  </a>,
  <a href="https://tailwindcss.com" className="focus:outline-none">
    <Icon className="text-4xl" icon={tailwindcssIcon} />
  </a>,
  <a href="https://expressjs.com/" className="focus:outline-none">
    <Icon className="text-5xl" icon={expressjsIcon} />
  </a>,
  <a href="https://www.mongodb.com/" className="focus:outline-none">
    <Icon className="text-6xl" icon={mongodbIcon} />
  </a>,
  <a href="https://firebase.google.com" className="focus:outline-none">
    <Icon className="text-5xl" icon={firebaseIcon} />
  </a>,
  <a href="https://nodejs.org" className="focus:outline-none">
    <Icon className="text-5xl" icon={nodejsIcon} />
  </a>,
  <a href="https://nextjs.org" className="focus:outline-none">
    <Icon className="text-5xl" icon={nextjsIcon} />
  </a>,
];

export default skills;
